import Toast, { BaseToast, ErrorToast } from 'react-native-toast-message';
import { fontPalette } from '../static/styles/global';

/*
  1. Create the config
*/
export const toastConfig = {
    /*
      Overwrite 'success' type,
      by modifying the existing `BaseToast` component
    */
    success: (props) => (

        <BaseToast
            {...props}
            style={{ borderLeftColor: 'green', height: 'auto', zIndex: 9999 }}
            contentContainerStyle={{ padding: 15 }}
            text1NumberOfLines={0}
            text2NumberOfLines={0}
            text1Style={{
                fontSize: 16,
                fontFamily: fontPalette.primarySemiBold,
                flexWrap: 'wrap',
            }}

        />

    ),

    error: (props) => (
        <ErrorToast
            {...props}
            style={{ borderLeftColor: 'red', height: 'auto', zIndex: 9999 }}
            contentContainerStyle={{ padding: 15 }}
            text1NumberOfLines={0}
            text2NumberOfLines={0}
            text1Style={{
                fontSize: 16,
                fontFamily: fontPalette.primarySemiBold,
                flexWrap: 'wrap',
            }}
        />
    ),
};